import axios, { type AxiosInstance } from 'axios';
import { useAuthStore } from './auth-store';
import { getApiBaseUrl, getMaterialidadBaseUrl } from '@rfacil/shared/constants';

/**
 * @constant apiSSO
 * @description Una instancia de Axios configurada para realizar solicitudes a la API del servicio SSO.
 * Incluye un interceptor para añadir automáticamente el token de autorización a las cabeceras de cada solicitud.
 * @type {AxiosInstance}
 */
export const apiSSO: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  maxRedirects: 0, // Prevenir redirecciones automáticas que puedan ocultar errores
});

apiSSO.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Agregar timestamp para evitar caché de respuestas entre usuarios
  config.params = {
    ...config.params,
    _t: Date.now(),
  };
  return config;
});

// Interceptor de respuesta para manejar errores 401 (no autorizado)
apiSSO.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Si recibimos un 401, limpiar el estado de autenticación
      const authStore = useAuthStore.getState();
      if (authStore.isAuthenticated) {
        authStore.logout();
      }
    }
    return Promise.reject(error);
  }
);

/**
 * @constant apiMaterialidad
 * @description Una instancia de Axios configurada para realizar solicitudes a la API del servicio Materialidad.
 * Incluye un interceptor para añadir automáticamente el token de autorización a las cabeceras de cada solicitud.
 * @type {AxiosInstance}
 */
export const apiMaterialidad: AxiosInstance = axios.create({
  baseURL: getMaterialidadBaseUrl(),
  maxRedirects: 0, // Prevenir redirecciones automáticas que puedan ocultar errores
});

apiMaterialidad.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Agregar timestamp para evitar caché de respuestas entre usuarios
  config.params = {
    ...config.params,
    _t: Date.now(),
  };
  return config;
});

// Interceptor de respuesta para manejar errores 401 (no autorizado)
apiMaterialidad.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Si recibimos un 401, limpiar el estado de autenticación
      const authStore = useAuthStore.getState();
      if (authStore.isAuthenticated) {
        authStore.logout();
      }
    }
    return Promise.reject(error);
  }
);

